import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleZoom } from "../../../actions";
import Layers from "../../Canvas/Layers";
import "./Preview.css";

class Preview extends React.Component {
  render() {
    return (
      <div className="review__preview">
        <div className="preview-container">
          <Layers disableInteractivity={true} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleZoom
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
